export default "__VITE_ASSET__eb886251__"